import { render } from "./WizardFinal.vue?vue&type=template&id=64b829be&scoped=true"
import script from "./WizardFinal.vue?vue&type=script&lang=js"
export * from "./WizardFinal.vue?vue&type=script&lang=js"

import "./WizardFinal.vue?vue&type=style&index=0&id=64b829be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64b829be"

export default script